export default {
  permissions: {
    // Exact match for the raw string from backend in Italian
    'users view': 'Visualizza Utenti',
    'users create': 'Crea Nuovi Utenti',
    'users edit': 'Modifica Utenti',
    'users delete': 'Elimina Utenti',
    'roles view': 'Visualizza Ruoli & Permessi',
    'roles manage': 'Gestisci Ruoli & Permessi',
  },
  roles: {
    manager: 'Manager',
    editor: 'Editor',
    viewer: 'Visualizzatore',
  }
}
